// src/pages/Resources/HelpCenterPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider, List, ListItem, ListItemText, Link } from '@mui/material';
import { Help, Email, Phone, Chat } from '@mui/icons-material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const HelpCenterPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Help Center
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Find answers, get support, and learn how to make the most of Rengigs.
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Help sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Frequently Asked Questions</Typography>
        </Box>

        <List>
          <ListItem>
            <ListItemText primary="How do I create an account?" secondary="Click 'Join Now' in the top right, fill in your details, and verify your email." />
          </ListItem>
          <ListItem>
            <ListItemText primary="How does pricing work?" secondary="We offer monthly and yearly premium plans for organizations and suppliers. See our Pricing page for details." />
          </ListItem>
          <ListItem>
            <ListItemText primary="How do I post a problem?" secondary="Organizations can post problems from their dashboard. Suppliers can then tag their solutions." />
          </ListItem>
          <ListItem>
            <ListItemText primary="How do I list a solution?" secondary="Suppliers can list solutions from the Solutions page. You need an active organization membership." />
          </ListItem>
          <ListItem>
            <ListItemText primary="How do I cancel my subscription?" secondary="Go to your dashboard → Subscriptions → Cancel subscription. Your access will continue until the end of the billing period." />
          </ListItem>
        </List>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Email sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Contact Support</Typography>
        </Box>
        <Typography variant="body1" paragraph>
          Can't find what you're looking for? Our support team is here to help.
        </Typography>
        <ul>
          <li><Typography variant="body1">Email: <Link href="mailto:support@rengigs.com" sx={{ color: RENGIGS.green }}>support@rengigs.com</Link></Typography></li>
          <li><Typography variant="body1">Response time: Within 24 hours</Typography></li>
        </ul>

        <Divider sx={{ my: 4 }} />

        
      </Paper>
    </Container>
  );
};

export default HelpCenterPage;